<template>
  <span>
    <span v-if="product" @click.stop>
      <a
        v-if="product.id"
        :href="priceUrl(product.id)"
        target="_blank"
      >{{ product.name }}</a>
    </span>
  </span>
</template>
<script type="ts">
import Vue from 'vue';
import StripeProduct from '@/datatypes/stripe/product';

export default Vue.extend({
  name: 'product-text',
  props: {
    product: {
      type: StripeProduct,
      default: undefined,
    },
  },
  methods: {
    priceUrl(productId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].product(productId);
    },
  },
});
</script>
